import { render, staticRenderFns } from "./config-textbox.vue?vue&type=template&id=1f6251e9&scoped=true"
import script from "./config-textbox.vue?vue&type=script&lang=js"
export * from "./config-textbox.vue?vue&type=script&lang=js"
import style0 from "./config-textbox.vue?vue&type=style&index=0&id=1f6251e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6251e9",
  null
  
)

export default component.exports